import { LookupValueDto } from "../app/model/api/types/dto";
import { LookupViewModel } from "./lookupViewModel";

export class LookupValueViewModel extends LookupViewModel {
  lookupTypeId: Array<string> | null;
  lookupGroupId: Array<string> | null;

  constructor(
    id: string | null,
    name: string | null,
    description: string | null,
    lookupTypeId: Array<string> | null,
    lookupGroupId: Array<string> | null,
    sortValue: number | null,
    isActive: boolean | null
  ) {
    super(id, name, description, sortValue, isActive);
    this.lookupTypeId = lookupTypeId;
    this.lookupGroupId = lookupGroupId;
  }

  toDto(): LookupValueDto {
    return {
      id: this.id,
      isActive: this.isActive,
      name: this.name,
      description: this.description,
      typeId:
        this.lookupTypeId !== null && this.lookupTypeId?.length > 0
          ? this.lookupTypeId[0]
          : null,
      groupId:
        this.lookupGroupId !== null && this.lookupGroupId?.length > 0
          ? this.lookupGroupId[0]
          : null,
      sortValue: Number(this.sortValue),
    };
  }

  mapFromDto(dto: LookupValueDto): void {
    super.mapFromDto(dto);
    dto.typeId !== null
      ? this.lookupTypeId?.push(dto.typeId)
      : (this.lookupTypeId = null);
    dto.groupId !== null
      ? this.lookupGroupId?.push(dto.groupId)
      : (this.lookupGroupId = null);
  }
}
